import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CacheService, ITypeCategoryProfessionalBO } from '@mapfre-tech/amap3';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProfessionalCategoryService {

  className = 'ProfessionalCategoryService';

  constructor(private http: HttpClient, private cacheService: CacheService) { }

  getAll(cache = true, cacheKey = "allProfessionalCategories"): Observable<ITypeCategoryProfessionalBO[]> {
    if (this.cacheService.canUseCache(cacheKey) && cache) {
      return this.cacheService.getCacheData(cacheKey) as object as Observable<ITypeCategoryProfessionalBO[]>;
    } else {
      const observable = this.http.get<ITypeCategoryProfessionalBO[]>(environment.base_URL + "/professional-category-types").pipe(map((res) => {
      this.cacheService.updateCacheData(res, cacheKey)
      return res;
      }))
      this.cacheService.updateCacheReq(cacheKey);
      return observable;
    }
  }

  newCategory(category: ITypeCategoryProfessionalBO) {
    return this.http.post(environment.base_URL + "/professional-category-types", category).pipe(tap(() => this.deleteCache()))
  }

  updateCategory(category: ITypeCategoryProfessionalBO, id: number) {
    return this.http.put(environment.base_URL + `/professional-category-types/${id}`, category).pipe(tap(() => this.deleteCache()))
  }

  deleteCache() {
    this.cacheService.deleteCache('allProfessionalCategories');
  }
}
